/* Scoped bundle selectors: every selection order resolves to one physical mix. */
(() => {
  if (customElements.get('rp-bundle-mix-picker')) return;

  class RPBundleMixPicker extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.map = JSON.parse(this.querySelector('[data-bundle-map]').textContent);
      this.selects = [...this.querySelectorAll('select')];
      this.status = this.querySelector('[data-bundle-status]');
      this.retry = this.querySelector('[data-bundle-retry]');
      this.onSelection = this.loadSelection.bind(this);
      this.addEventListener('change', this.onSelection);
      this.retry.addEventListener('click', this.onSelection);
      this.loadSelection();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.removeEventListener('change', this.onSelection);
      this.retry?.removeEventListener('click', this.onSelection);
      this.initialized = false;
    }

    get forms() {
      return [...document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)];
    }

    setButton(disabled, text) {
      this.forms.forEach((form) => {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) variantInput.disabled = disabled;
        const expressPayment = form.querySelector('.shopify-payment-button');
        if (expressPayment) expressPayment.style.display = disabled ? 'none' : '';
        const button = form.querySelector('[name="add"]');
        if (!button) return;
        button.disabled = disabled;
        const label = button.querySelector('span');
        if (text && label) label.textContent = text;
      });
    }

    async loadSelection(event) {
      if (event?.type === 'change' && !this.selects.includes(event.target)) return;
      const values = this.selects.map((select) => this.map.flavours.indexOf(select.value));
      const key = [...values].sort((a, b) => a - b).join('-');
      const variantId = values.every((value) => value >= 0) && this.map.mixes[key];
      const sequence = this.sequence = (this.sequence || 0) + 1;
      this.controller?.abort();
      this.controller = new AbortController();
      this.setButton(true);
      this.setAttribute('aria-busy', 'true');
      this.retry.hidden = true;
      this.status.textContent = 'Checking mix…';
      if (!variantId) {
        this.status.textContent = 'This mix could not be found. Please choose your flavours again.';
        this.removeAttribute('aria-busy');
        return;
      }

      const controller = this.controller;
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Product request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (sequence !== this.sequence || !this.isConnected) return;
        const renderedPicker = html.getElementById(this.id);
        const selected = renderedPicker?.querySelector('[data-bundle-current]');
        if (!selected) throw new Error('Selected mix missing');
        const variant = JSON.parse(selected.textContent);
        if (String(variant.id) !== String(variantId)) throw new Error('Selected mix mismatch');

        ['price', 'Inventory', 'Sku'].forEach((prefix) => {
          const id = `${prefix}-${this.dataset.section}`;
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
            destination.classList.remove('visibility-hidden');
            if (prefix === 'Sku') destination.classList.toggle('visibility-hidden', !source.textContent.trim());
          }
        });
        this.forms.forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          if (!input) return;
          input.value = variantId;
          input.disabled = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        const serverButton = html.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        const disabled = !variant.available || !serverButton || serverButton.hasAttribute('disabled');
        this.setButton(disabled, serverButton?.querySelector('span')?.textContent.trim() || (disabled ? window.variantStrings?.soldOut : window.variantStrings?.addToCart));
        this.status.textContent = variant.available ? '' : 'This mix is currently sold out. Please choose another mix.';
        this.currentVariant = variant;
        if (this.dataset.updateUrl !== 'false' && (event || new URL(location.href).searchParams.has('variant'))) {
          const currentUrl = new URL(location.href);
          currentUrl.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', currentUrl);
        }
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (shareButton?.updateUrl) shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
        const pickup = this.closest('section')?.querySelector('pickup-availability');
        if (pickup) {
          if (variant.available) pickup.fetchAvailability(variantId);
          else { pickup.removeAttribute('available'); pickup.innerHTML = ''; }
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: this.dataset.section, html, variant } });
        }
      } catch (error) {
        if (sequence !== this.sequence || !this.isConnected) return;
        this.setButton(true);
        this.status.textContent = 'We couldn’t check this mix. Please try again.';
        this.retry.hidden = false;
      } finally {
        clearTimeout(timeout);
        if (sequence === this.sequence) this.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('rp-bundle-mix-picker', RPBundleMixPicker);
})();
